export class CONST {
  static laNhaPhone = '0941-446-571';
  static laNhaEmail = 'info@fittamodular.com';
  static laNhaFacebook =
    'https://www.facebook.com/Fitta.combonoithatfitchomoinha';
  static laNhaZalo = 'https://zalo.me/580536086382319158';
  static laNhaIns = 'https://www.instagram.com/noithatfitta/';
  static laNhaMessenger = 'https://m.me/919370914582612';
  static laNhaWebsite = 'https://www.fitta.vn';
  static laNhaTaxId = '0319478866';
}

export const STATUS_OPTIONS = [
  'Create order',
  'Confirm order',
  'Board manufacturing',
  'Furniture manufacturing',
  'Transport',
  // 'Delivery',
  'Construction & Installation',
  'Completed',
  'Order cancelled',
];

export const PRODUCT_OPTIONS = [
  'Wardrobe',
  'Kitchen cabinet',
  'Shoe cabinet',
  'TV cabinet',
  'Decorative Cabinet',
  'Vanity cabinet',
  'Desk',
  'Bed',
];

export const AMOUNT_OPTIONS = [
  '< 5 million',
  '5 million ~ 10 million',
  '10 million ~ 20 million',
  '20 million ~ 30 million',
  '30 million ~ 40 million',
  '40 million ~ 50 million',
  '50 million ~ 60 million',
  '> 60 million',
];
